import React from 'react';
import * as ReactDOMServer from 'react-dom/server';

function getGridClass(size) {
    return 'col-sm-4 col-xs-6';
}

function TaxonomyPill(props) {
    if (props[0]) {
        return <a href={props[0].term_link} className="pill post__term">{props[0].name}</a>;
    }

    return null
}

function PostComponent(props) {
    const jsx = (
        <div className={getGridClass(props.size)}>
            <article className="post post--post" data-aos="fade-up" data-aos-once="true">
                <div className="post__picture">
                    <a href={props.permalink} dangerouslySetInnerHTML={{__html: props.thumbnail}}></a>
                    {TaxonomyPill(props.services)}
                </div>
                <div className="post__details">
                    <h3 className="h4 post__title">
                        <a href={props.permalink}>{props.post_title}</a>
                    </h3>
                    <p className="post__date">
                        {props.the_date}
                    </p>
                </div>
            </article>
        </div>
    );

    return ReactDOMServer.renderToString(jsx);
}

export default PostComponent;
